import React, { FC, useCallback, useEffect, useMemo, useState } from "react"
import { ExclusiveChoiceDropdown } from "dash-styled"
import { turbine } from "neql"

interface QualificationTestChooserProps {
    trainingTests: turbine.TrainingTest[]
    value: string | undefined
    onChange: (value: string | undefined) => void
}

export const QualificationTestChooser: FC<QualificationTestChooserProps> = ({
    trainingTests,
    value,
    onChange
}) => {
    const [trainingTestSearch, setTrainingTestSearchResult] =
        useState<turbine.TrainingTest[]>(trainingTests)
    const [trainingName, setTrainingName] =
        useState<string | undefined>(undefined)

    const handleChangeName = useCallback(
        (choice: turbine.TrainingTest) => {
            onChange(choice.trainingId)
        },
        [onChange]
    )
    const renderChoice = useCallback(
        (choice: turbine.TrainingTest) => choice.taskInfo?.title ?? "",
        []
    )

    const selectedValue = useMemo(
        () =>
            trainingTestSearch.find(
                test => String(test.trainingId) === String(value)
            ),
        [trainingTestSearch, value]
    )

    useEffect(() => {
        if (trainingName !== undefined) {
            const searchTrainingName = trainingName.toLowerCase()
            setTrainingTestSearchResult(
                trainingTests.filter(test =>
                    test.taskInfo?.title
                        ?.toLowerCase()
                        .includes(searchTrainingName)
                )
            )
        }
    }, [trainingName, trainingTests])

    return (
        <ExclusiveChoiceDropdown
            className="w-full flex-grow flex-shrink mb-1"
            testId="qualifier-test-chooser"
            size="sm"
            choices={trainingTestSearch}
            value={selectedValue}
            onClick={handleChangeName}
            onSearch={setTrainingName}
            renderChoice={renderChoice}
        />
    )
}
